import React from 'react';
import { StyleProp, View, ViewStyle } from 'react-native';
import { mainContentPadding } from '../MainContentContainer';

export type DrawerContentContainerOwnProps = {
    children: React.ReactNode;
    style?: StyleProp<ViewStyle>;
};

export type DrawerContentContainerProps = DrawerContentContainerOwnProps;

const DrawerContentContainer: React.FC<DrawerContentContainerProps> = ({ children, style }) => {
    return <View style={[{ padding: mainContentPadding }, style]}>{children}</View>;
};

export default React.memo(DrawerContentContainer);
